module.exports = __webpack_public_path__ + "img/1533699312.80d9f48e.jpg";